import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { LoginPage } from "@/features/auth/LoginPage";
import { meQuery, safeReturnTo } from "@/features/auth/session";

const SearchSchema = z.object({
  returnTo: z.string().optional(),
  error: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: SearchSchema,
  beforeLoad: async ({ context, search }) => {
    // Already signed in: go where they were heading.
    const me = await context.queryClient
      .query({ ...meQuery, staleTime: "static" })
      .catch(() => null);
    if (me) throw redirect({ to: safeReturnTo(search.returnTo) });
  },
  component: LoginPage,
});
